module.exports = __webpack_public_path__ + "img/fullscreen-exit.6a8a3a3d.svg";